/**
 * 动态设置浏览器页签图标（按所选学校 / URL 里的学校 code 显示该校校徽）
 * 图标地址会缓存到本地，刷新页面后自动恢复，避免登录后刷新又变回默认图标
 */
const DEFAULT_FAVICON = 'favicon.ico'
// 缓存当前学校校徽地址的 key
const SCHOOL_FAVICON_KEY = 'ss-schoolFavicon'

function getIconLink() {
  let link = document.querySelector("link[rel*='icon']")
  if (!link) {
    link = document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    document.getElementsByTagName('head')[0].appendChild(link)
  }
  return link
}

/**
 * 获取学校附件（校徽）的完整访问地址
 * @param path 附件相对路径（如校徽 logo 字段）
 */
export function getFileAccessHttpUrl(path) {
  if (!path) {
    return ''
  }
  if (path.indexOf('http') === 0) {
    return path
  }
  return `${process.env.VUE_APP_BASE_API}/sys/common/static/${path}`
}

/**
 * 设置页签图标
 * @param iconUrl 图标完整访问地址，为空时恢复默认图标
 */
export function updateFavicon(iconUrl) {
  const baseUrl = process.env.BASE_URL || '/'
  const link = getIconLink()
  link.href = iconUrl ? iconUrl : baseUrl + DEFAULT_FAVICON
  // 缓存该校校徽，页面刷新后可恢复
  if (iconUrl) {
    localStorage.setItem(SCHOOL_FAVICON_KEY, iconUrl)
  } else {
    localStorage.removeItem(SCHOOL_FAVICON_KEY)
  }
}

/**
 * 恢复上次设置的学校页签图标（页面刷新 / 重新进入时使用）
 */
export function restoreFavicon() {
  const iconUrl = localStorage.getItem(SCHOOL_FAVICON_KEY)
  if (!iconUrl) {
    return
  }
  getIconLink().href = iconUrl
}

/**
 * 清除学校页签图标缓存并恢复默认图标（登出时使用）
 */
export function clearFavicon() {
  localStorage.removeItem(SCHOOL_FAVICON_KEY)
  const baseUrl = process.env.BASE_URL || '/'
  getIconLink().href = baseUrl + DEFAULT_FAVICON
}
